"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlexContext = void 0;
var react_1 = __importDefault(require("react"));
/**
 * FlexContext
 * @type {React.Context<{store: {}}>}
 */
exports.FlexContext = react_1.default.createContext({
  direction: 'vertical',
  gutter: 0,
  children: []
});